import Vue from "vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from "./App.vue";
import {store} from "./store/store.js";
import Vue2TouchEvents from "vue2-touch-events";
import VueConfetti from 'vue-confetti'
import Notifications from 'vue-notification'
import CanvasVideo from 'vue-canvasvideo'
import 'vue-canvasvideo/dist/vuecanvasvideo.min.css'


// import VueSimpleAlert from "vue-simple-alert";
//
// Vue.use(VueSimpleAlert);

// Vue.prototype.$pusher = new Pusher('e50fb6be6b7df82fb347', {
//   cluster: 'ap2',
//   // encrypted: true
// });

// Vue.prototype.$pusher = new Pusher('60b70543fe2e5f6aaf34', {
//   cluster: 'ap1',
//   // encrypted: true
// });
// Vue.prototype.$channel = null;
// Vue.prototype.$pusher.logToConsole = true;
// // localStorage.removeItem("channel")
// // if (!store.state.subscribed_channel && store.state.channel == null){
// if (localStorage.getItem("channel") == null){
//   store.dispatch('subscribeToChannel',true);
// }
// Vue.prototype.$channel  = store.state.subscribed_channel;

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'app-key',
  cluster: 'ap1',
  wsHost: 'halisi.tuni.ke',
  wsPort: '443',
  wssPort: '443',
  forceTLS: false,
  encrypted: true,
  enableLogging: true,
  disableStats: true,
  enabledTransports: ['ws','wss'],
});

Vue.use(CanvasVideo)
Vue.use(Notifications);

Vue.use(VueConfetti);
Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);
Vue.use(VueAxios, axios)
Vue.prototype.$appName = "Tuni Trivia";
//axios.defaults.headers.common['X-Frame-Options'] = 'ALLOWALL'
new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
